var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandWithCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_39869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4448 5.46479H13.7053C13.5259 5.46479 13.3804 5.31923 13.3804 5.13987V1.69466C13.3804 0.760331 14.1407 0 15.0752 0C16.0097 0 16.7699 0.760168 16.7699 1.69466V5.13987C16.7697 5.31939 16.6243 5.46479 16.4448 5.46479ZM14.0302 4.81494H16.1198V1.69466C16.1198 1.11856 15.6511 0.649855 15.075 0.649855C14.4988 0.649855 14.0301 1.11856 14.0301 1.69466L14.0302 4.81494Z",
    fill: "url(#paint0_linear_1_39869)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1096 2.41113C8.89166 2.41113 3.46529 7.29731 2.2313 13.8888C2.22691 13.9122 2.23276 13.934 2.24787 13.9523C2.26306 13.9707 2.28353 13.9803 2.30741 13.9803H27.9119C27.9357 13.9803 27.9561 13.9707 27.9713 13.9524C27.9864 13.9341 27.9923 13.9123 27.988 13.889C26.7585 7.2974 21.3322 2.41113 15.1096 2.41113ZM29.9842 15.0919C29.9691 15.0721 29.9477 15.0615 29.9227 15.0615H0.300999C0.276061 15.0615 0.254616 15.0721 0.239588 15.0919C0.224479 15.1117 0.21993 15.1353 0.226672 15.1593C0.508384 16.1733 1.43768 16.9205 2.54243 16.9205H27.6815C28.7817 16.9205 29.7152 16.1733 29.9972 15.1593C30.0038 15.1354 29.9993 15.1118 29.9842 15.0919Z",
    fill: "url(#paint1_linear_1_39869)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45896 27.874L3.50978 21.9133C3.3644 21.7676 3.12941 21.7676 2.98403 21.9133L1.49673 23.4035C1.35135 23.5491 1.35135 23.7846 1.49673 23.9302L7.4459 29.891C7.51841 29.9636 7.6136 30.0001 7.70878 30.0001C7.80397 30.0001 7.89916 29.9636 7.97166 29.891L9.45896 28.4008C9.60434 28.2551 9.60434 28.0197 9.45896 27.874ZM22.4798 19.1963C21.361 20.3147 19.7845 21.7732 18.794 22.1767H15.8889C15.7602 22.1767 15.6472 22.1111 15.5803 22.0116C16.479 21.594 18.2455 20.8128 18.9341 20.6798C19.7945 20.5136 20.3508 19.9313 20.3508 19.1963H12.4265C10.0528 20.175 7.08747 21.4781 5.23021 22.5831L9.38459 26.7456C11.672 26.4177 13.3757 26.4095 14.9106 26.4028C16.0101 26.398 17.0486 26.3935 18.16 26.2721C21.0528 25.9573 24.3646 21.2442 25.676 19.1963H22.4798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_39869",
    x1: 15.0751,
    y1: 0,
    x2: 15.0751,
    y2: 5.46479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47E0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_39869",
    x1: 15.1119,
    y1: 2.41113,
    x2: 15.1119,
    y2: 16.9205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47E0E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_39869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWithCover);
export default __webpack_public_path__ + "static/media/hand-with-cover.df683f0ac34ab79c99e1179bfa1062a5.svg";
export { ForwardRef as ReactComponent };